import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { DollarSign, Users, TrendingUp, Target, ShoppingCart, Percent, Wallet } from "lucide-react";

export default function FunnelOverviewCards({ overview }) {
  const cards = [
    {
      title: "Total Funnel Spend",
      value: `$${overview.totalFunnelSpend.toLocaleString()}`,
      subtitle: "(all stages)",
      icon: DollarSign,
      color: "text-blue-500",
      bgColor: "bg-blue-50 dark:bg-blue-950",
    },
    {
      title: "Total Leads",
      value: overview.totalLeads.toLocaleString(),
      subtitle: "(all stages)",
      icon: Users,
      color: "text-green-500",
      bgColor: "bg-green-50 dark:bg-green-950",
    },
    {
      title: "Funnel CAC",
      value: `$${overview.funnelCac.toFixed(2)}`,
      subtitle: "(full funnel)",
      icon: Target,
      color: "text-orange-500",
      bgColor: "bg-orange-50 dark:bg-orange-950",
    },
    {
      title: "Funnel ROAS",
      value: `${overview.funnelRoas}x`,
      subtitle: "(full funnel)",
      icon: TrendingUp,
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      title: "Customers",
      value: overview.customers.toLocaleString(),
      subtitle: "closed won",
      icon: ShoppingCart,
      color: "text-purple-500",
      bgColor: "bg-purple-50 dark:bg-purple-950",
    },
    {
      title: "Revenue",
      value: `$${overview.revenue.toLocaleString()}`,
      subtitle: "attributed",
      icon: DollarSign,
      color: "text-emerald-500",
      bgColor: "bg-emerald-50 dark:bg-emerald-950",
    },
    {
      title: "Conversion Rate",
      value: `${overview.conversionRate.toFixed(1)}%`,
      subtitle: "lead → customer",
      icon: Percent,
      color: "text-cyan-500",
      bgColor: "bg-cyan-50 dark:bg-cyan-950",
    },
    {
      title: "Profit",
      value: `$${overview.profit.toLocaleString()}`,
      subtitle: "revenue - spend",
      icon: Wallet,
      color: overview.profit >= 0 ? "text-green-500" : "text-destructive",
      bgColor: overview.profit >= 0 ? "bg-green-50 dark:bg-green-950" : "bg-destructive/10",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card key={index} className="border-border hover:shadow-md transition-shadow">
            <CardContent className="p-6">
              <div className="flex items-center justify-between mb-4">
                <div className={`p-3 rounded-lg ${card.bgColor}`}>
                  <Icon className={`h-5 w-5 ${card.color}`} />
                </div>
              </div>
              <div>
                <p className="text-sm font-medium text-muted-foreground">{card.title}</p>
                <p className="text-2xl font-bold text-foreground mt-1">{card.value}</p>
                <p className="text-xs text-muted-foreground mt-1">{card.subtitle}</p>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
